import fetch from 'isomorphic-fetch'

const _fetch = (method) => async (url, options = {}) => {
  const opts = {
    headers: {
      Accept: 'application/json'
    },
    credentials: 'include',
    redirect: 'follow',
    ...options,
    method
  }

  if (opts.body && !(opts.body instanceof FormData)) {
    opts.headers['Content-Type'] = 'application/json'
    opts.body = JSON.stringify(opts.body)
  }

  try {
    const response = await fetch(url, opts)
    const length = response.headers.get('content-length')
    const body = length !== '0' && response.status !== 204
      ? await response.json()
      : {}

    return {
      body,
      headers: response.headers,
      status: response.status
    }
  } catch (err) {
    throw new Error(err)
  }
}

export default {
  get: _fetch('GET'),
  post: _fetch('POST'),
  put: _fetch('PUT'),
  patch: _fetch('PATCH'),
  delete: _fetch('DELETE')
}
